import { Component, ojs, app, v, state, payload } from "modular-openscriptjs";
import {
    acknowledge,
    cleanDispose,
    eParse,
    either,
    fireEvent,
    hideActionButton,
    inform,
    processEnd,
    processStart,
} from "../../helpers";
import { dom, tool } from "../../fotastart";
import { $e } from "../../ojs.events";
import { uc } from "../../ojs.contexts";
import Swal from "sweetalert2";
import { api, STRINGS } from "../../declarations";
import { routes } from "../../backendRoutes";

const h = app("h");

export default class SubscriptionPlansForm extends Component {
    holder = null;
    plansState = state([]);
    stepState = state(1);
    selectedPlanState = state(null);
    paymentMethodState = state("capa");

    $$subscription = {
        needs: {
            plans: () => {
                this.stepState.value = 1;
                this.selectedPlanState.value = null;
                this.paymentMethodState.value = "capa";
                this.showForm();
            },
            closePlans: () => this.closeForm(),
        },
        has: {
            plans: (ed) => {
                let data = eParse(ed);
                this.plansState.value = data.message.plans;
            },
        },
    };

    closeForm() {
        if (this.holder) {
            this.holder.hide();
        }
    }

    getFeatureLabel(key, value) {
        switch (key) {
            case "number_of_orders":
                return value == 0
                    ? "Unlimited orders"
                    : `${value} orders per cycle`;
            case "maximum_delivery_radius":
                return `Up to ${value} km delivery radius`;
            case "maximum_items_per_order":
                return `Upto ${value} items per order`;
            case "order_editing":
                return value === "true" ||
                    value === true ||
                    value === 1 ||
                    value === "1"
                    ? "Order editing"
                    : "Order editing";
            case "ai_credits":
                return `${value} AI credits (Add custom items, order using voice, extract items from images)`;
            case "order_scheduling":
                return value === "true" ||
                    value === true ||
                    value === 1 ||
                    value === "1"
                    ? "Order scheduling"
                    : "Order scheduling";
            case "concurrent_orders":
                return `Place at most ${Number(value) + 1} orders at the same time`;
            case "virtual_distance":
                return `${value} delivery tokens`;
            case "minimal_purchase_size":
                return `Order From Just KES ${value}`;
            case "concurrency_multiplier":
                return `${value}x concurrency multiplier`;
            case "virtual_distance_to_effort":
                return `${value} virtual distance-to-effort ratio`;
            default:
                return `${key.replace(/_/g, " ")}: ${value}`;
        }
    }

    getProvisionIcon(key, val) {
        if (key === "ai_credits") {
            return "bi-stars text-dark";
        }

        const isFalse =
            val === "false" || val === false || val === 0 || val === "0";
        if (isFalse) {
            return "bi-x-circle-fill text-danger";
        }

        return "bi-check-circle-fill text-success";
    }

    selectPlan(plan) {
        this.selectedPlanState.value = plan;
        this.stepState.value = 2;
    }

    prevStep() {
        if (this.stepState.value === 3) {
            this.stepState.value = 2;
        } else if (this.stepState.value === 2) {
            this.stepState.value = 1;
            this.selectedPlanState.value = null;
        }
    }

    showForm() {
        if (this.holder) {
            cleanDispose(this.holder);
        }

        hideActionButton();

        let options = new tool.ModalOptions();
        options.buttons.left.visible = false;
        options.buttons.right.visible = false;
        options.classes.dialog = "modal-fullscreen";
        options.classes.content =
            "border-0 shadow-lg subscription-gradient-modal";
        options.classes.header =
            "bg-transparent border-0 pt-4 px-4 pb-0 fs-3 fw-bold";

        let modalBody = h.div(
            {
                class: "p-3 text-dark subscription-modal-body subscription-font-large px-lg-5",
            },
            v(this.stepState, (step) => {
                if (step.value === 1) {
                    return h.div(
                        h.p(
                            { class: "text-muted text-center mb-4" },
                            "Choose a subscription plan to get unlimited orders, scheduled deliveries, unlock premium features, and AI credits.",
                        ),
                        v(this.plansState, (plans) => {
                            if (!plans.value || plans.value.length === 0) {
                                return h.div(
                                    {
                                        class: "d-flex justify-content-center py-5",
                                    },
                                    h.div({
                                        class: "spinner-border text-primary",
                                        role: "status",
                                    }),
                                );
                            }

                            let orderedPlans = [];
                            let basic = plans.value.find(
                                (p) => p.slug === "basic-plan",
                            );
                            let smart = plans.value.find(
                                (p) => p.slug === "smart-plan",
                            );
                            let group = plans.value.find(
                                (p) => p.slug === "group-plan",
                            );

                            if (basic) orderedPlans.push(basic);
                            if (smart) orderedPlans.push(smart);
                            if (group) orderedPlans.push(group);

                            if (orderedPlans.length === 0) {
                                orderedPlans = plans.value;
                            }

                            return h.div(
                                { class: "row g-4 justify-content-center" },
                                orderedPlans.map((plan) => {
                                    const isRecommended = plan.is_recommended;

                                    // Find virtual distance value
                                    const vkmProv = plan.provisions
                                        ? plan.provisions.find(
                                              (prov) =>
                                                  prov.key ===
                                                  "virtual_distance",
                                          )
                                        : null;
                                    const vkmValue = vkmProv
                                        ? vkmProv.value
                                        : 0;

                                    // Filter and sort provisions
                                    const orderMap = {
                                        maximum_delivery_radius: 1,
                                        ai_credits: 2,
                                        maximum_items_per_order: 3,
                                        concurrent_orders: 4,
                                        minimal_purchase_size: 5,
                                        order_editing: 6,
                                        order_scheduling: 7,
                                    };

                                    const filteredProvisions = plan.provisions
                                        ? plan.provisions
                                              .filter((prov) => {
                                                  if (
                                                      prov.key ===
                                                      "concurrency_multiplier"
                                                  )
                                                      return false;
                                                  if (
                                                      prov.key ===
                                                      "virtual_distance_to_effort"
                                                  )
                                                      return false;
                                                  if (
                                                      prov.key ===
                                                      "virtual_distance"
                                                  )
                                                      return false;
                                                  if (
                                                      prov.key ===
                                                          "number_of_orders" &&
                                                      Number(prov.value) === 0
                                                  )
                                                      return false;
                                                  return true;
                                              })
                                              .sort((a, b) => {
                                                  return (
                                                      (orderMap[a.key] || 99) -
                                                      (orderMap[b.key] || 99)
                                                  );
                                              })
                                        : [];

                                    const provisionElements =
                                        filteredProvisions.map((prov) => {
                                            const iconClass =
                                                this.getProvisionIcon(
                                                    prov.key,
                                                    prov.value,
                                                );

                                            return h.li(
                                                {
                                                    class: "d-flex align-items-start gap-2 mb-2 text-start small text-secondary",
                                                },
                                                h.i({
                                                    class: `bi ${iconClass} mt-0.5`,
                                                }),
                                                h.span(
                                                    this.getFeatureLabel(
                                                        prov.key,
                                                        prov.value,
                                                    ),
                                                ),
                                            );
                                        });

                                    return h.div(
                                        {
                                            class: "col-12 col-md-4",
                                            id: `plan-card-${plan.slug}`,
                                        },
                                        h.div(
                                            {
                                                class: `card h-100 rounded-4 shadow-sm transition-all duration-300 ${
                                                    isRecommended
                                                        ? "border-2 border-primary bg-light-primary scale-105"
                                                        : "border border-secondary-subtle bg-white"
                                                }`,
                                                style: isRecommended
                                                    ? "border: 2px solid #5d5fef; transform: scale(1.03); background-color: #f7f7ff;"
                                                    : "border: 1px solid rgba(0, 0, 0, 0.12);",
                                            },
                                            isRecommended
                                                ? h.div(
                                                      {
                                                          class: "badge bg-primary text-white text-uppercase fw-bold rounded-top-4 py-2 text-center",
                                                      },
                                                      "Best Value",
                                                  )
                                                : null,
                                            h.div(
                                                {
                                                    class: "card-body p-4 d-flex flex-column",
                                                },
                                                h.h5(
                                                    {
                                                        class: "fw-bold text-dark mb-1",
                                                    },
                                                    plan.name,
                                                ),
                                                h.p(
                                                    {
                                                        class: "text-muted small mb-3 text-start",
                                                    },
                                                    plan.description,
                                                ),

                                                // Highlighted vKM and smaller price
                                                h.div(
                                                    {
                                                        class: `my-3 text-center p-3 rounded-3 ${isRecommended ? "bg-primary-subtle" : "bg-light"}`,
                                                    },
                                                    h.div(
                                                        {
                                                            class: "fs-1 fw-extrabold text-primary mb-1",
                                                            style: "color: #5d5fef;",
                                                        },
                                                        `${vkmValue} vKM`,
                                                    ),
                                                    h.div(
                                                        {
                                                            class: "small text-muted mb-1 fw-semibold text-uppercase font-monospace",
                                                        },
                                                        "Delivery Tokens",
                                                    ),
                                                    h.p(
                                                        {
                                                            class: "text-muted mb-2 lh-sm px-2",
                                                            style: "font-size: 0.72rem;",
                                                        },
                                                        "Tokens are consumed instead of paying delivery fees.",
                                                    ),
                                                    h.div(
                                                        {
                                                            class: "text-secondary font-monospace",
                                                        },
                                                        h.span(
                                                            {
                                                                class: "fs-6 fw-bold text-dark",
                                                            },
                                                            `KES ${Number(plan.price).toLocaleString()}`,
                                                        ),
                                                        h.span(
                                                            { class: "small" },
                                                            ` / ${plan.interval_count} ${plan.interval}`,
                                                        ),
                                                    ),
                                                ),

                                                // Highlight savings on delivery fee
                                                plan.saving_benefit
                                                    ? h.div(
                                                          {
                                                              class: "alert border-0 rounded-3 py-2 px-3 mb-3 d-flex gap-2 align-items-center",
                                                              style: "background-color: rgba(254, 210, 125, 0.15); color: #fed27d; border: 1px solid rgba(254, 210, 125, 0.3);",
                                                          },
                                                          h.i({
                                                              class: "bi bi-piggy-bank-fill fs-5",
                                                          }),
                                                          h.span(
                                                              {
                                                                  class: "small fw-bold",
                                                              },
                                                              `Save over KES ${Number(plan.saving_benefit).toLocaleString()} on delivery fees`,
                                                          ),
                                                      )
                                                    : null,

                                                h.hr({
                                                    class: "my-3 text-muted",
                                                }),
                                                h.ul(
                                                    {
                                                        class: "list-unstyled flex-grow-1 mb-4",
                                                    },
                                                    ...provisionElements,
                                                ),
                                                h.div(
                                                    {
                                                        class: "d-flex mb-2 justify-content-center text-muted fs-xsm text-center",
                                                    },
                                                    h.span(
                                                        "You can change or cancel your plan anytime.",
                                                    ),
                                                ),
                                                plan.has_trial &&
                                                    plan.trial_plan
                                                    ? h.div(
                                                          {
                                                              class: "w-100 text-center mb-3",
                                                          },
                                                          h.div(
                                                              {
                                                                  class: "py-1 px-3 fw-bold rounded-pill d-inline-block",
                                                                  style: "background-color: rgba(254, 210, 125, 0.15); color: #fed27d; border: 1px solid rgba(254, 210, 125, 0.3); font-size: 0.85rem;",
                                                              },
                                                              `${plan.trial_plan.interval_count}-Day Free Trial`,
                                                          ),
                                                      )
                                                    : null,
                                                (() => {
                                                    const activeSub =
                                                        uc.subscription.value;
                                                    const hasActive =
                                                        activeSub &&
                                                        activeSub.id &&
                                                        (activeSub.status ===
                                                            "active" ||
                                                            activeSub.status ===
                                                                "trialing");
                                                    const activePlanPrice =
                                                        hasActive
                                                            ? Number(
                                                                  activeSub.plan
                                                                      ?.price ||
                                                                      0,
                                                              )
                                                            : 0;
                                                    const activePlanId =
                                                        hasActive
                                                            ? activeSub.plan?.id
                                                            : null;

                                                    let btnText = plan.has_trial
                                                        ? "Start Trial"
                                                        : "Select Plan";
                                                    let isDisabled = false;

                                                    if (hasActive) {
                                                        if (
                                                            plan.id ===
                                                            activePlanId
                                                        ) {
                                                            btnText =
                                                                "Current Plan";
                                                            isDisabled = true;
                                                        } else if (
                                                            Number(plan.price) >
                                                            activePlanPrice
                                                        ) {
                                                            btnText =
                                                                "Upgrade Plan";
                                                        } else {
                                                            btnText =
                                                                "Downgrade Plan";
                                                        }
                                                    }

                                                    return h.button(
                                                        {
                                                            class: `btn btn-lg w-100 rounded-pill fw-bold ${
                                                                isRecommended
                                                                    ? "btn-primary"
                                                                    : "btn-outline-dark"
                                                            }`,
                                                            onclick:
                                                                this.method(
                                                                    "selectPlan",
                                                                    [plan],
                                                                ),
                                                            ...(isDisabled
                                                                ? {
                                                                      disabled: true,
                                                                  }
                                                                : {}),
                                                        },
                                                        btnText,
                                                    );
                                                })(),
                                            ),
                                        ),
                                    );
                                }),
                            );
                        }),
                    );
                } else if (step.value === 2) {
                    // Step 2: Select Payment Method
                    return v(this.selectedPlanState, (planVal) => {
                        const plan = planVal.value;
                        if (!plan) return null;

                        return h.div(
                            {
                                class: "checkout-step-2 text-white mx-auto",
                                style: "max-width: 580px;",
                            },
                            h.button(
                                {
                                    class: "btn btn-link text-decoration-none mb-4 d-flex align-items-center gap-1 p-0 fw-semibold text-white",
                                    style: "color: #fed27d !important;",
                                    onclick: this.method("prevStep"),
                                },
                                h.i({ class: "bi bi-arrow-left fs-5" }),
                                "Back to Plans",
                            ),
                            h.h4(
                                {
                                    class: "fw-extrabold text-white mb-4 text-center",
                                },
                                `Select Payment Method`,
                            ),
                            h.p(
                                {
                                    class: "text-secondary text-center small mb-4",
                                },
                                `Choose how you want to fund your ${plan.name}`,
                            ),

                            h.div(
                                { class: "d-flex flex-column gap-3 mb-4" },
                                this.renderPaymentMethodOption(
                                    "mpesa",
                                    "Lipa Na M-Pesa",
                                    "bi-phone",
                                    "Use Mpesa Standing Orders to pay subscription fees",
                                ),

                                // this.renderPaymentMethodOption(
                                //     "capa",
                                //     "My Capa Wallet",
                                //     "bi-wallet2",
                                //     "Use my Carata Capa Wallet to Pay",
                                // ),
                                // this.renderPaymentMethodOption(
                                //     "card",
                                //     "Credit / Debit Card",
                                //     "bi-credit-card",
                                //     "Pay using your credit or debit Cards",
                                // ),
                            ),

                            h.button(
                                {
                                    class: "btn btn-primary btn-lg w-100 rounded-pill py-3 fw-bold shadow-sm transition-all hover-scale",
                                    style: "background-color: #5d5fef; border-color: #5d5fef;",
                                    onclick: this.method("goToDetailsStep"),
                                },
                                "Continue",
                            ),
                        );
                    });
                } else if (step.value === 3) {
                    // Step 3: Checkout details & inputs based on method
                    return v(this.selectedPlanState, (planVal) => {
                        const plan = planVal.value;
                        if (!plan) return null;

                        const hasTrial = plan.has_trial && plan.trial_plan;
                        const trialDays = hasTrial
                            ? Number(plan.trial_plan.interval_count)
                            : 0;

                        // Calculate trial end date
                        let trialEndStr = "";
                        if (hasTrial) {
                            const date = new Date();
                            date.setDate(date.getDate() + trialDays);
                            trialEndStr = date.toLocaleDateString(undefined, {
                                month: "short",
                                day: "numeric",
                                year: "numeric",
                            });
                        }

                        return h.div(
                            {
                                class: "checkout-step-3 text-white mx-auto",
                                style: "max-width: 580px;",
                            },
                            h.button(
                                {
                                    class: "btn btn-link text-decoration-none mb-4 d-flex align-items-center gap-1 p-0 fw-semibold text-white",
                                    style: "color: #fed27d !important;",
                                    onclick: this.method("prevStep"),
                                },
                                h.i({ class: "bi bi-arrow-left fs-5" }),
                                "Back to Payment Methods",
                            ),
                            h.h4(
                                {
                                    class: "fw-extrabold text-white mb-4 text-center",
                                },
                                `Confirm your ${plan.name}`,
                            ),

                            h.div(
                                { class: "d-flex flex-column gap-3 mb-4" },

                                v(this.paymentMethodState, (method) => {
                                    if (method.value === "capa") {
                                        return h.div(
                                            {
                                                class: "card border border-secondary-subtle rounded-4 p-4 d-flex flex-row gap-3 align-items-start",
                                            },
                                            h.div(
                                                {
                                                    class: "fs-1 animate-float",
                                                    style: "color: #fed27d;",
                                                },
                                                h.i({ class: "bi bi-wallet2" }),
                                            ),
                                            h.div(
                                                h.h6(
                                                    {
                                                        class: "fw-bold text-white mb-1",
                                                    },
                                                    "Automatic Capa Wallet Deduction",
                                                ),
                                                h.p(
                                                    {
                                                        class: "text-secondary small mb-0 lh-base",
                                                    },
                                                    `Carata will use your `,
                                                    h.strong("Capa Wallet"),
                                                    ` to deduct your subscription fee of `,
                                                    h.strong(
                                                        `KES ${Number(plan.price).toLocaleString()}`,
                                                    ),
                                                    ` every ${plan.interval_count} ${plan.interval}.`,
                                                ),
                                            ),
                                        );
                                    } else if (method.value === "mpesa") {
                                        const rawPhone =
                                            gc.user?.value?.phone ?? "";
                                        const phoneDigits = rawPhone.substring(
                                            rawPhone.length - 9,
                                        );

                                        return h.div(
                                            {
                                                class: "card border border-secondary-subtle rounded-4 p-4 d-flex flex-column gap-3",
                                            },
                                            either(activeSub, () =>
                                                h.div(
                                                    {
                                                        class: "d-flex gap-3 align-items-start",
                                                    },
                                                    h.div(
                                                        {
                                                            class: "fs-1",
                                                            style: "color: #fed27d;",
                                                        },
                                                        h.i({
                                                            class: "bi bi-info-circle",
                                                        }),
                                                    ),
                                                    h.div(
                                                        h.h6(
                                                            {
                                                                class: "fw-bold text-white mb-1",
                                                            },
                                                            "M-Pesa Instruction",
                                                        ),
                                                        h.p(
                                                            {
                                                                class: "text-secondary small mb-0 lh-base",
                                                            },
                                                            `If you previously subscribed with Mpesa, please use the Mpesa App to remove any current recurring payment to Carata (Mpesa Ratiba)`,
                                                        ),
                                                    ),
                                                ),
                                            ),
                                            h.div(
                                                {
                                                    class: "d-flex gap-3 align-items-start",
                                                },
                                                h.div(
                                                    {
                                                        class: "fs-1",
                                                        style: "color: #fed27d;",
                                                    },
                                                    h.i({
                                                        class: "bi bi-phone",
                                                    }),
                                                ),
                                                h.div(
                                                    h.h6(
                                                        {
                                                            class: "fw-bold text-white mb-1",
                                                        },
                                                        "M-Pesa STK Push Prompt",
                                                    ),
                                                    h.p(
                                                        {
                                                            class: "text-secondary small mb-0 lh-base",
                                                        },
                                                        `An M-Pesa STK push request will be sent to the number below to authorize recurring payments of `,
                                                        h.strong(
                                                            `KES ${Number(plan.price).toLocaleString()}`,
                                                        ),
                                                        ` every ${plan.interval_count} ${plan.interval}.`,
                                                    ),
                                                ),
                                            ),
                                            h.div(
                                                {
                                                    class: "form-group mt-2 text-start",
                                                },
                                                h.label(
                                                    {
                                                        class: "form-label text-secondary small fw-bold mb-1",
                                                    },
                                                    "Phone Number",
                                                ),
                                                h.div(
                                                    { class: "input-group" },
                                                    h.span(
                                                        {
                                                            class: "input-group-text bg-transparent text-white border-secondary-subtle",
                                                        },
                                                        "+254",
                                                    ),
                                                    h.input({
                                                        type: "tel",
                                                        id: "subscription-phone-input",
                                                        class: "form-control bg-transparent text-white border-secondary-subtle",
                                                        placeholder:
                                                            "7XXXXXXXX",
                                                        value: phoneDigits,
                                                    }),
                                                ),
                                            ),
                                        );
                                    } else if (method.value === "card") {
                                        const rawEmail =
                                            gc.user?.value?.email ?? "";

                                        return h.div(
                                            {
                                                class: "card border border-secondary-subtle rounded-4 p-4 d-flex flex-column gap-3",
                                            },
                                            h.div(
                                                {
                                                    class: "d-flex gap-3 align-items-start",
                                                },
                                                h.div(
                                                    {
                                                        class: "fs-1",
                                                        style: "color: #fed27d;",
                                                    },
                                                    h.i({
                                                        class: "bi bi-credit-card",
                                                    }),
                                                ),
                                                h.div(
                                                    h.h6(
                                                        {
                                                            class: "fw-bold text-white mb-1",
                                                        },
                                                        "Credit/Debit Card",
                                                    ),
                                                    h.p(
                                                        {
                                                            class: "text-secondary small mb-0 lh-base",
                                                        },
                                                        `Your card will be charged `,
                                                        h.strong(
                                                            `KES ${Number(plan.price).toLocaleString()}`,
                                                        ),
                                                        ` every ${plan.interval_count} ${plan.interval}.`,
                                                    ),
                                                ),
                                            ),
                                            h.div(
                                                {
                                                    class: "form-group mt-2 text-start",
                                                },
                                                h.label(
                                                    {
                                                        class: "form-label text-secondary small fw-bold mb-1",
                                                    },
                                                    "Email Address",
                                                ),
                                                h.input({
                                                    type: "email",
                                                    id: "subscription-email-input",
                                                    class: "form-control bg-transparent text-white border-secondary-subtle",
                                                    placeholder:
                                                        "your.email@domain.com",
                                                    value: rawEmail,
                                                }),
                                            ),
                                        );
                                    }
                                    return null;
                                }),

                                // Card 2: Trial info or subscription start
                                hasTrial
                                    ? h.div(
                                          {
                                              class: "card border border-secondary-subtle rounded-4 p-4 d-flex flex-row gap-3 align-items-start",
                                          },
                                          h.div(
                                              {
                                                  class: "fs-1",
                                                  style: "color: #fed27d;",
                                              },
                                              h.i({
                                                  class: "bi bi-calendar-check",
                                              }),
                                          ),
                                          h.div(
                                              h.h6(
                                                  {
                                                      class: "fw-bold mb-1",
                                                      style: "color: #fed27d;",
                                                  },
                                                  `${trialDays}-Day Free Trial Included`,
                                              ),
                                              h.p(
                                                  {
                                                      class: "text-secondary small mb-0 lh-base",
                                                  },
                                                  `Your free trial will last for `,
                                                  h.strong(`${trialDays} days`),
                                                  ` (ends on `,
                                                  h.strong(trialEndStr),
                                                  `). After the trial ends, Carata will charge your payment method to keep your subscription active.`,
                                              ),
                                          ),
                                      )
                                    : h.div(
                                          {
                                              class: "card border border-secondary-subtle rounded-4 p-4 d-flex flex-row gap-3 align-items-start",
                                          },
                                          h.div(
                                              {
                                                  class: "fs-1",
                                                  style: "color: #fed27d;",
                                              },
                                              h.i({
                                                  class: "bi bi-lightning-charge",
                                              }),
                                          ),
                                          h.div(
                                              h.h6(
                                                  {
                                                      class: "fw-bold mb-1",
                                                      style: "color: #fed27d;",
                                                  },
                                                  "Subscription Starts Immediately",
                                              ),
                                              h.p(
                                                  {
                                                      class: "text-secondary small mb-0 lh-base",
                                                  },
                                                  `Your subscription will activate immediately. Please ensure your payment method has sufficient balance to complete the initial charge.`,
                                              ),
                                          ),
                                      ),
                            ),

                            v(this.paymentMethodState, (method) => {
                                if (method.value === "capa") {
                                    return v(uc.capa, (capaState) => {
                                        const capaBalance =
                                            capaState.value?.balance ?? 0;
                                        const exchangeRate =
                                            window.systemConfigs?.capaExchangeRate ?? 1;
                                        const kesBalance =
                                            capaBalance * exchangeRate;
                                        const isInsufficient =
                                            !hasTrial &&
                                            kesBalance < plan.price;

                                        return h.button(
                                            {
                                                class: "btn btn-primary btn-lg w-100 rounded-pill py-3 fw-bold shadow-sm transition-all hover-scale",
                                                style: "background-color: #5d5fef; border-color: #5d5fef;",
                                                onclick: isInsufficient
                                                    ? this.method(
                                                          "depositAndSubscribe",
                                                          [plan],
                                                      )
                                                    : this.method(
                                                          "subscribeToPlan",
                                                          [
                                                              plan.id,
                                                              hasTrial
                                                                  ? plan.trial_id
                                                                  : null,
                                                              "capa",
                                                          ],
                                                      ),
                                            },
                                            isInsufficient
                                                ? `Deposit KES ${Number(plan.price).toLocaleString()}`
                                                : hasTrial
                                                  ? `Start ${trialDays}-Day Free Trial`
                                                  : "Confirm & Subscribe",
                                        );
                                    });
                                } else {
                                    return h.button(
                                        {
                                            class: "btn btn-primary btn-lg w-100 rounded-pill py-3 fw-bold shadow-sm transition-all hover-scale",
                                            style: "background-color: #5d5fef; border-color: #5d5fef;",
                                            onclick: this.method(
                                                "submitSubscription",
                                                [plan, hasTrial],
                                            ),
                                        },
                                        hasTrial
                                            ? `Start ${trialDays}-Day Free Trial`
                                            : "Confirm & Subscribe",
                                    );
                                }
                            }),
                        );
                    });
                } else if (step.value === 4) {
                    // Step 4: Waiting for authorization
                    return h.div(
                        {
                            class: "checkout-step-4 text-white text-center py-5 mx-auto",
                            style: "max-width: 580px;",
                        },
                        h.div({
                            class: "spinner-border text-light mb-4",
                            role: "status",
                            style: "width: 3rem; height: 3rem;",
                        }),
                        h.h4(
                            { class: "fw-bold text-white mb-2" },
                            "Waiting for Authorization",
                        ),
                        h.p(
                            { class: "text-secondary" },
                            "Please complete authorization on your device. Checking status...",
                        ),
                    );
                }
            }),
        );

        const activeSub = uc.subscription.value;
        const hasActive =
            activeSub &&
            activeSub.id &&
            (activeSub.status === "active" || activeSub.status === "trialing");
        const modalTitle = hasActive
            ? "Change Subscription Plan"
            : "Choose what works best for You";

        let modal = tool.modal(modalTitle, modalBody, options);
        this.holder = modal.modal.object;
        this.holder.show();

        setTimeout(() => {
            let smartPlanEl = dom.get("#plan-card-smart-plan");
            if (smartPlanEl) {
                smartPlanEl.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }, 1000);
    }

    selectPaymentMethod(method) {
        this.paymentMethodState.value = method;
    }

    goToDetailsStep() {
        this.stepState.value = 3;
    }

    renderPaymentMethodOption(value, label, iconClass, description = null) {
        return v(this.paymentMethodState, (currentMethod) => {
            const isSelected = currentMethod.value === value;
            return h.div(
                {
                    class: `card border rounded-4 cursor-pointer transition-all ${
                        isSelected
                            ? "border-primary bg-primary-subtle"
                            : "border-secondary-subtle bg-dark-subtle"
                    }`,
                    style: "transition: all 0.2s ease-in-out; background-color: rgba(255, 255, 255, 0.03);",
                    onclick: this.method("selectPaymentMethod", [value]),
                },
                h.div(
                    {
                        class: "card-body p-3 d-flex align-items-center gap-3 text-white",
                    },
                    h.div(
                        {
                            class: "border border-primary-subtle rounded-circle d-flex align-items-center justify-content-center",
                            style: "width: 48px; height: 48px; min-width: 48px;",
                        },
                        h.i({
                            class: `bi ${iconClass} fs-5 ${isSelected ? "text-primary" : "text-white"}`,
                        }),
                    ),
                    h.div(
                        { class: "flex-grow-1 text-start" },
                        h.div(
                            {
                                class: "d-flex justify-content-between align-items-center",
                            },
                            h.h6({ class: "mb-0 fw-bold" }, label),
                            h.div(
                                isSelected
                                    ? h.i({
                                          class: "bi bi-check-circle-fill text-primary fs-4",
                                          style: "color: #5d5fef;",
                                      })
                                    : h.i({
                                          class: "bi bi-circle text-secondary fs-4",
                                      }),
                            ),
                        ),
                        description
                            ? h.small({ class: "text-secondary" }, description)
                            : null,
                    ),
                ),
            );
        });
    }

    pollingInterval = null;

    startPolling(subscriptionId) {
        this.stopPolling();
        this.pollingInterval = setInterval(async () => {
            let res = await api.get(
                `${routes.subscriptions}/${subscriptionId}`,
                {},
                { silent: true },
            );
            if (res && res.data && res.data.subscription) {
                let sub = res.data.subscription;

                // Anything other than "pending" means the authorization attempt has
                // already been processed one way or another (e.g. a failed
                // authorization cancels the subscription) - there's nothing left to
                // wait on, so keep polling only while it's still pending.
                if (sub.status === "pending") {
                    return;
                }

                this.stopPolling();

                if (sub.status === "active" || sub.status === "trialing") {
                    // The modal only gets hidden once we actually have a confirmed
                    // active subscription - a non-active outcome below intentionally
                    // leaves it open and just switches the step back instead.
                    if (this.holder) {
                        this.holder.hide();
                    }
                    uc.subscription.value = sub;

                    fireEvent(
                        $e.subscription.has.active,
                        payload({ subscription: sub }),
                    );

                    fireEvent($e.capa.needs.balance);

                    acknowledge({
                        title: "Subscription Started",
                        message:
                            "Your subscription has successfully started. A universe of possibilities awaits you",
                        close_text: "That's Fantastic",
                    });
                    return;
                }

                // Not active (e.g. "canceled" - authorization failed and the
                // subscription was canceled by the provider, or any other
                // non-pending, non-active outcome) - send the customer back to the
                // details step, still inside the same modal, with an explanation.
                this.goToDetailsStep();
                inform(
                    "Authorization failed. Your subscription was not successful, please try again.",
                    STRINGS.ERROR,
                );
            }
        }, 5000);
    }

    stopPolling() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    }

    cleanUp() {
        this.stopPolling();
        super.cleanUp();
    }

    submitSubscription(plan, hasTrial) {
        const method = this.paymentMethodState.value;

        if (method === "mpesa") {
            const phoneInput = dom.id("subscription-phone-input");
            if (!phoneInput || !phoneInput.value.trim()) {
                return inform("Invalid Phone Number", STRINGS.ERROR);
            }

            let phoneVal = phoneInput.value.trim();

            this.subscribeToPlan(
                plan.id,
                hasTrial ? plan.trial_id : null,
                "mpesa",
                {
                    number: phoneVal,
                    payment_type: "credit",
                    type: "phone",
                },
            );
        } else if (method === "card") {
            const emailInput = dom.id("subscription-email-input");
            if (!emailInput || !emailInput.value.trim()) {
                return inform("Please enter a valid Email", STRINGS.ERROR);
            }
            let emailVal = emailInput.value.trim();

            this.subscribeToPlan(
                plan.id,
                hasTrial ? plan.trial_id : null,
                "card",
                {
                    email: emailVal,
                },
            );
        }
    }

    async subscribeToPlan(planId, trialId, method = "capa", information = {}) {
        if (method === "capa") {
            information = {
                capa_id: uc.capa?.value?.id ?? 0,
            };
        }

        processStart();

        let res = await api.post(routes.subscriptions, {
            plan_id: planId,
            trial_id: trialId,
            method: method,
            information: information,
        });

        processEnd();

        if (res && res.data && res.data.authorization) {
            let auth = res.data.authorization;
            let action = auth.action;

            if (action === "next") {
                if (this.holder) {
                    this.holder.hide();
                }
                fireEvent($e.subscription.needs.active);
                fireEvent($e.capa.needs.balance);

                acknowledge({
                    title: "Subscription Started",
                    message:
                        "Your subscription has successfully started. A universe of possibilities awaits you",
                    close_text: "That's Fantastic",
                });
            } else if (action === "wait") {
                const redirectUrl = auth.toUrl || auth.to_url;
                if (redirectUrl) {
                    const a = document.createElement("a");
                    a.href = redirectUrl;
                    a.target = "_blank";
                    a.rel = "noopener noreferrer";
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }

                this.stepState.value = 4;

                const subscriptionId =
                    auth.model?.subscription_id || auth.subscription_id;
                if (subscriptionId) {
                    this.startPolling(subscriptionId);
                } else {
                    console.error(
                        "No subscription ID found in authorization response",
                    );
                }
            }
        }
    }

    depositAndSubscribe(plan) {
        if (this.holder) {
            this.holder.hide();
        }

        fireEvent($e.capa.needs.depositForm);
    }
}

ojs(SubscriptionPlansForm);
